import { render } from "./HelloSign.vue?vue&type=template&id=3da6333c"
import script from "./HelloSign.vue?vue&type=script&lang=js"
export * from "./HelloSign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__